"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M5.4 5.4v13.2h13.2V5.4H5.4zm9.896 9.612h-2.254l-2.126-3.129v3.13H8.703v-6.04h2.254l2.127 3.12v-3.12h2.212v6.04z" }), "Naver");
//# sourceMappingURL=Naver.js.map